import { useQuery } from "@tanstack/react-query";
import { getNavigation } from "../../api/apiStorefront";
import i18next from "i18next";

/**
 * Hook لجلب بيانات القائمة الرئيسية (Navigation)
 * Returns departments with nested categories and brands
 */
export function useGetNavigation() {
    const {
        isLoading,
        data,
        error,
        refetch,
    } = useQuery({
        queryKey: ["navigation", i18next.language],
        queryFn: () => getNavigation(),
        retry: false,
        staleTime: 1000 * 60 * 60, // Cache for 1 hour as per API documentation
    });

    const navigation = data?.data || null;

    return { isLoading, error, navigation, refetch };
}
